import React, { useEffect, useState } from 'react';
import { Table, Alert} from 'antd';
import axios from '@common/axios';
import CircularLoader from "@common/CircularLoader";

const ScorcherActivities = ({ step}) => {
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!step) {
            setResults([]);
            setError(null);
            setLoading(false);
            return;
        }

        setLoading(true);
        setError(null);

        const fetchResults = async () => {
            try {
                const response = await axios.get('/web/ui/trail/scorcher/results', {
                    params: { stepId: step.stepId, pathwayUserId: step.pathwayUserId }
                });
                setResults(response.data);
            } catch (err) {
                setError('Failed to load scorcher results.');
                setResults([]);
            } finally {
                setLoading(false);
            }
        };

        fetchResults();
    }, [step]);

    if (loading) return <CircularLoader/>;

    if (error) return <Alert type="error" message={error} />;

    if (results.length === 0) {
        return <Alert type="warning" message="No results found." />;
    }

    const totalScore = results.reduce((sum, r) => sum + r.score, 0);
    const totalTimeMilliSeconds = results.reduce((sum, r) => sum + r.time, 0);
    const formattedTotalTime = new Date(totalTimeMilliSeconds).toISOString().substr(11, 8);
    const maxScore = 10 * results.length;
    const percent = Math.round((totalScore * 100) / maxScore);

    const columns = [
        {
            title: 'Result',
            dataIndex: 'result',
            render: (_, __, index) =>
                results.length > 1 ? `Scorcher set ${index + 1}` : 'Scorcher set',
        },
        {
            title: 'Time',
            dataIndex: 'formattedTime',
        },
        {
            title: 'Score',
            dataIndex: 'score',
            render: (_, record) => `${record.score}/10 (${record.correctPercent}%)`,
        },
    ];

    const dataSource = results.map((r, index) => ({
        key: index,
        ...r,
    }));

    return (
        <div className="pw-card-padd">
            <Table
                dataSource={dataSource}
                columns={columns}
                pagination={false}
                bordered
                footer={() =>
                    results.length > 1 && (
                        <div className="ch-scorcher-summary">
                            <strong>Total:</strong> {formattedTotalTime}{' '}
                            | <strong>Score:</strong> {totalScore}/{maxScore} ({percent}%)
                        </div>
                    )
                }
            />
        </div>
    );
};

export default ScorcherActivities;
